import React from 'react';

/** The [start, end) spans of `text` that any word covers, case-insensitively, merged where they touch or overlap. */
export function hitSpans(text, terms) {
  const lower = text.toLowerCase();
  if (lower.length !== text.length) return [];
  const spans = [];
  (terms || []).forEach((term) => {
    const word = term ? term.toLowerCase() : '';
    if (!word) return;
    for (let at = lower.indexOf(word); -1 !== at; at = lower.indexOf(word, at + 1)) {
      spans.push([at, at + word.length]);
    }
  });
  spans.sort((a, b) => a[0] - b[0]);
  return spans.reduce((merged, span) => {
    const last = merged[merged.length - 1];
    if (last && span[0] <= last[1]) last[1] = Math.max(last[1], span[1]);
    else merged.push([...span]);
    return merged;
  }, []);
}

/** `text` with every span a word covers wrapped in `<mark className="bh-hit">`; with no hit, the plain string. */
export default function Highlight({ text, terms }) {
  const value = undefined === text || null === text ? '' : String(text);
  const spans = hitSpans(value, terms);
  if (!spans.length) return value;
  const parts = [];
  let at = 0;
  spans.forEach(([start, end]) => {
    if (start > at) parts.push(value.slice(at, start));
    parts.push(<mark key={start} className="bh-hit">{value.slice(start, end)}</mark>);
    at = end;
  });
  if (at < value.length) parts.push(value.slice(at));
  return <>{parts}</>;
}
